export const CLIENT_QUOTATION_STATUSES = Object.freeze({
    "ACTIVE": 1,
    "INACTIVE": 2,
    "APPROVED": 3,
    "REJECTED": 4,
})